import {
  AVATAR_BADGE_SIZE,
  AvatarBasic,
  SvgIcon,
} from '@npco/zeller-design-system'

import { ReactComponent as MobileIcon } from 'assets/svg/payment-source/mobile.svg'
import { ReactComponent as TerminalIcon } from 'assets/svg/payment-source/terminal.svg'

import * as styled from './DeviceCard.styled'

type DeviceAvatarProps = {
  isMobile: boolean
}

export const DeviceAvatar = ({ isMobile }: DeviceAvatarProps) => {
  return (
    <styled.AvatarContainer>
      <AvatarBasic
        text=""
        badgeSize={AVATAR_BADGE_SIZE.SMALL}
        userDefinedContent={
          <SvgIcon width="16" height="16">
            {isMobile ? <MobileIcon /> : <TerminalIcon />}
          </SvgIcon>
        }
      />
    </styled.AvatarContainer>
  )
}
